import { Button } from 'antd'
import clsx from 'clsx'
import { useMemo } from 'react'

import { useLocalStorage } from '@/context/localstorage-context'

export default function StepOne({
  setStep,
}: {
  setStep: (val: number) => void
}) {
  const { theme } = useLocalStorage()
  const isDark = useMemo(() => theme === 'dark', [theme])
  const btnCln = clsx('w-full flex justify-around mt-[20px]', {
    'btn1-light': !isDark,
    'btn1-dark': isDark,
  })
  return (
    <div>
      <div className="border-b-1 border-b-light-555 dark:border-b-dark-666">
        <p className="text-3xl text-light-111 mb-[0] dark:text-dark-111">
          Node Overview & Requirements
        </p>
        <p className="text-xl text-light-444 my-[10px]">
          Before becoming a Wanchain PoS Validator (Galaxy Consensus Node),
          please ensure your environment meets the hardware and staking
          requirements below.
        </p>
      </div>
      <div className="flex mt-[10px] dark:text-white">
        <div className="flex-1 flex flex-col">
          <span className="text-[14px] font-inter font-semibold text-light-0 dark:text-white">
            Hardware Requirements
          </span>
          <div className="grid grid-cols-2 gap-[1px] grid-auto-rows:100px text-[13px] mt-[5px] dark:bg-dark-333">
            <div className="font-bold bg-light-888 px-6 py-2 text-light-999 rounded-tl-[10px] dark:bg-dark-333 dark:text-dark-0">
              Item
            </div>
            <div className="font-bold bg-light-888 px-6 py-2 text-light-999 rounded-tr-[10px] dark:bg-dark-333 dark:text-dark-0">
              Requirement (Minimum)
            </div>
            <div className="bg-light-888 px-6 py-2 text-light-999 dark:bg-dark-333 dark:text-dark-0">
              CPU
            </div>
            <div className="bg-light-888 px-6 py-2 text-light-111 dark:bg-dark-333 font-medium">
              4 cores
            </div>
            <div className="bg-light-888 px-6 py-2 text-light-999 dark:bg-dark-333 dark:text-dark-0">
              RAM
            </div>
            <div className="bg-light-888 px-6 py-2 text-light-111 dark:bg-dark-333 font-medium">
              8 GB
            </div>
            <div className="bg-light-888 px-6 py-2 text-light-999 dark:bg-dark-333 dark:text-dark-0">
              Disk Space
            </div>
            <div className="bg-light-888 px-6 py-2 text-light-111 dark:bg-dark-333 font-medium">
              200 GB
            </div>
            <div className="bg-light-888 px-6 py-2 text-light-999 rounded-bl-[10px] dark:bg-dark-333 dark:text-dark-0">
              Operating System
            </div>
            <div className="bg-light-888 px-6 py-2 text-light-111 rounded-br-[10px] dark:bg-dark-333 font-medium">
              Ubuntu 22.04
            </div>
          </div>
        </div>
      </div>
      <div className="flex mt-[15px] dark:text-white">
        <div className="flex-1 flex flex-col ">
          <span className="text-[14px] font-inter font-semibold text-light-0 dark:text-white">
            Staking Requirements
          </span>
          <div className="text-light-0 text-[13px] dark:text-dark-0 pl-[10px]">
            <ul className="list-disc pl-6 space-y-2">
              <li>
                <span className="font-semibold">Minimum Stake:</span>
                <ul className="list-disc pl-6 space-y-2">
                  <li>
                    <span className="font-semibold">Delegating Validator</span>:
                    50,000 WAN
                  </li>
                  <li>
                    <span className="font-semibold">
                      Non-delegating Validator
                    </span>
                    : 10,000 WAN
                  </li>
                </ul>
              </li>
              <li>
                <span className="font-semibold pr-2">Staking Period:</span>
                You may freely choose any period between{' '}
                <span className="font-semibold">7–90 days</span>.
              </li>
              <li>
                <span className="font-semibold pr-2">Node Exit:</span>
                After you initiate exit and your staking period has expired, you
                may withdraw your staked WAN
                <span className="font-semibold pl-[4px]">at any time</span>.
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="flex mt-[5px] dark:text-white">
        <div className="flex-1 flex flex-col">
          <span className="text-[14px] font-inter font-semibold text-light-0 dark:text-white">
            Registration Window
          </span>
          <span className="text-[13px] dark:text-dark-0">
            There is{' '}
            <span className="font-semibold">no fixed registration window.</span>{' '}
            You may register a Wanchain PoS node at any time.
          </span>
        </div>
      </div>
      <div className={btnCln}>
        <Button
          disabled
          className="w-[49%] rounded-2xl h-[60px] text-[18px] dark:bg-dark-666"
        >
          Previous
        </Button>
        <Button
          className="w-[49%] rounded-2xl h-[60px] btn text-[18px]"
          onClick={() => setStep(11)}
        >
          Next
        </Button>
      </div>
    </div>
  )
}
